import styled from 'styled-components';
import { InfoCircle } from '@styled-icons/boxicons-regular/InfoCircle';

export const Container = styled.div`
  position: absolute;
  top: -4px;
  right: 0;
`;

export const InfoIcon = styled(InfoCircle)`
  width: 1.25rem;
  color: ${({ theme }) => theme.colors.grayDark2};
`;
